import { useAlerting, useTranslation } from "src/hooks";
import { AddLedgerBalanceMonitorFields } from "..";
import { snakeCase } from "lodash";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { AlertType } from "src/api/types";

function useValidation() {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t, tc } = useTranslation(translatePrefix);
  const { alerting } = useAlerting();

  const validate = (fields: AddLedgerBalanceMonitorFields) => {
    try {
      const {
        thresholdLower,
        thresholdUpper,
        alertType,
        interval,
        ...apiParams
      } = fields;

      Object.entries(apiParams).forEach(([key, value]) => {
        if (!value) {
          throw tc(key === "clientId" ? "phInputField" : "phSelection", {
            fieldName: t(snakeCase(key)),
          });
        }
      });

      if (alertType === AlertType.FixedThreshold) {
        if (!thresholdLower && !thresholdUpper) {
          throw t("no_threshold_warning");
        }

        if (thresholdLower && thresholdUpper) {
          if (Number(fields.thresholdLower) >= Number(fields.thresholdUpper)) {
            throw t("invalid_threshold_warning");
          }
        }
      }

      if (
        alertType === AlertType.DynamicThreshold &&
        (!interval || Number(interval) <= 0)
      ) {
        throw t("missing_interval_warning");
      }
    } catch (message: any) {
      alerting("warning", message);
      return false;
    }

    return true;
  };

  return { validate };
}

export default useValidation;
